import React from 'react';
import './HomePage.css';
import Carousel from '../components/Carousel';

function HomePage() {
  
  const poster = '/videos/water-poster.jpg';

  return (
    <div className="page page-home">
      {/* Hero Section */}
      <section className="hero home-hero-bg">
  <video
    className="home-bg-video"
    src="/videos/water.mp4"
    poster={poster}
    autoPlay
    muted
    loop
    playsInline
  />
  
  <div className="home-hero-overlay" aria-hidden="true" />

  <div className="home-hero-content">
    <h1>Crystal Drops</h1>
    <h2 className="home-tagline">Pure Innovation in Water Technology</h2>
    <p className="home-lead"style={{color:"#d7fafe"}}>
      We deliver advanced water treatment solutions that combine sustainability,
      precision engineering, and unmatched expertise tailored to diverse
      industries and communities.
    </p>
    <div className="home-hero-cta">
      <a className="home-btn-primary" href="/contact">Request a Consultation</a>
      <a className="home-btn-ghost" href="/services">Explore Solutions</a>
    </div>
  </div>
</section>

{/*Description Section */}

<section className="home-description">
  <div className="home-desc-container">
    <h2 className="home-section-title">Solutions That Flow Beyond Boundaries</h2>
    <p className="home-description-text">
      Crystal Drops is a fast-growing service oriented company providing solutions in the field
      of water technology. We design and implement water treatment solutions that match the specific 
      needs of our clients. Our team of highly qualified technicians with in-depth industry experience,
      deliver advanced water treatment solutions to a diverse range of applications, including residential colonies, commercial 
      complexes, food and beverage, healthcare, and other industries.
    </p>
  </div>
</section>

{/* Client List */}
      <section className="clients">
      <h2 className="clients-heading">Trusted By Leading Brands</h2>
      <div className="clients-logos">
        <Carousel />
      </div>
    </section>

   {/* Value Proposition Section */}
      <section className="home-value-prop">
        <div className="home-container">
          <h2>Our Core Strengths</h2>
          <div className="value-grid">
            <div className="value-card">
              <h3>💡 Innovation</h3>
              <p>Cutting-edge designs and modular systems that adapt to evolving water challenges.</p>
            </div>
            <div className="value-card">
              <h3>🌍 Sustainability</h3>
              <p>Eco-conscious solutions that reduce waste, conserve resources, and protect communities.</p>
            </div>
            <div className="value-card">
              <h3>👨‍🔧 Expertise</h3>
              <p>Decades of technical know-how delivered by highly qualified engineers and technicians.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="home-page-intro">
        <div className="home-container">
          <h2>Tailored Water Solutions</h2>
          <p>
            From residential colonies to industrial complexes, Crystal Drops designs
            and implements systems that meet specific client needs. Our solutions
            span drinking water purification, wastewater treatment, and specialized
            industry applications.
          </p>
        </div>
      </section>
    </div>
  );
}

export default HomePage;